import { applicationPortals } from "./applicant-portals";
import { compliance } from "./compliance";
import { dashboard } from "./dashboard";
import { intakes } from "./intakes";
import { login } from "./login";
import { messages } from "./messages";
import { organizations } from "./organizations";
import { queue } from "./queue";
import { register } from "./register";
import { root } from "./root";
import { settings } from "./settings";
import { userManagement } from "./users";
import { workload } from "./workload";

export const app = {
  root,
  login,
  register,
  dashboard,
  intakes,
  applicationPortals,
  queue,
  workload,
  userManagement,
  organizations,
  compliance,
  settings,
  messages,
};
